import { useEffect } from 'react';

// Stops wheel events over the given element from scrolling the page, so zooming
// the 3D canvas does not also scroll the document. The event still reaches the
// canvas, which only reads the wheel delta.
export const usePreventPageScroll = (ref, enabled = true) => {
  useEffect(() => {
    const el = ref.current;
    if (!el || !enabled) return undefined;

    const preventScroll = e => e.preventDefault();
    const opts = { passive: false };

    el.addEventListener('wheel', preventScroll, opts);

    return () => {
      el.removeEventListener('wheel', preventScroll, opts);
    };
  }, [ ref, enabled ]);
};
